import { render, staticRenderFns } from "./popularFeelings.vue?vue&type=template&id=93f5c36a&scoped=true&"
import script from "./popularFeelings.vue?vue&type=script&lang=js&"
export * from "./popularFeelings.vue?vue&type=script&lang=js&"
import style0 from "./popularFeelings.vue?vue&type=style&index=0&id=93f5c36a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f5c36a",
  null
  
)

export default component.exports